import { __decorate } from "tslib";
import { LitElement, html, customElement } from 'lit-element';
let DemoPlaceholder = class DemoPlaceholder extends LitElement {
    render() {
        return html `
       <cds-grid>
        <cds-grid-column>Type</cds-grid-column>
        <cds-grid-column>Description</cds-grid-column>
        <cds-grid-column>Amount</cds-grid-column>
        <cds-grid-column>Balance</cds-grid-column>
        <cds-grid-placeholder>
          No items were found.
        </cds-grid-placeholder>
        <cds-grid-footer></cds-grid-footer>
      </cds-grid>
    `;
    }
    createRenderRoot() {
        return this;
    }
};
DemoPlaceholder = __decorate([
    customElement('demo-placeholder')
], DemoPlaceholder);
export { DemoPlaceholder };
//# sourceMappingURL=demo.placeholder.js.map